// 📄 services/authService.ts
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';

export const sendPasswordReset = async (email: string): Promise<void> => {
  await sendPasswordResetEmail(auth, email.trim().toLowerCase(), {
    url: `${window.location.origin}/`,
    handleCodeInApp: false,
  });
};
